import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const tantrumsSelfWill: BlogMetaData = {
  title: '思い通りにならないと癇癪…年齢別の原因と声かけ5選｜モンテッソーリ流対処法',
  description:
    '子どもが思い通りにならないと癇癪を起こす理由を年齢別（2〜5歳）に整理。モンテッソーリ教育の「選択肢を与える」アプローチとNG声かけ、今日から実践できる具体的な対処法5選を解説します。',
  thumbnailUrl: '/img/blog-tantrum-3-year-old.png',
  filePath: buildBlogFilePath('tantrums-self-will'),
  category: BLOG_CATEGORY.PARENTING,
};
